module.exports = __webpack_public_path__ + "img/nogifts.36af2943.jpg";